import { Grid, type IconJVSProps } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import './Outil.css';

interface OutilProps {
	icon: IconJVSProps;
	title: string;
}

const Outil = ({ icon, title }: OutilProps) => (
	<Grid className="outil">
		<Grid.Row className="outilRow">
			<Grid.Column width={2}>
				<Icon size={28} {...icon} />
			</Grid.Column>
			<Grid.Column width={14}>{title}</Grid.Column>
		</Grid.Row>
	</Grid>
);

export default Outil;
